<template>
    <div class="san-biao-container">
        <div class="card-container" v-if="Status.LoadingCompleted">
            <div class="search-box">
                <el-input 
                    v-model="CurSearch" 
                    placeholder="请输入考生号/姓名/证件号码/学号" 
                    clearable
                    @keyup.enter.native="OnSearch(2)"
                    style="width: 350px;">
                    <i slot="prefix" class="el-icon-search"></i>
                </el-input>
                <el-button type="primary" icon="el-icon-search" @click="OnSearch(2)">查询</el-button>
                <el-button icon="el-icon-refresh" @click="OnSearch(1)">重置</el-button>
                <el-button type="success" icon="el-icon-download" @click="showExportDialog">导出考生名单</el-button>
                <el-button type="warning" icon="el-icon-files" @click="showDownloadDialog">下载三表</el-button>
            </div>

            <!-- 未导入统计标签栏 -->
            <div class="alert-bar">
                <el-tooltip content="点击可筛选出缺失照片的考生" placement="top">
                    <span class="alert-tag alert-tag-red" v-if="noPhotoCount > 0" @click="filterNoPhoto">
                        <i class="el-icon-picture-outline"></i>
                        <span>照片未导入：{{ noPhotoCount }}人</span>
                    </span>
                </el-tooltip>
                <el-tooltip content="点击可筛选出缺失体检表的考生" placement="top">
                    <span class="alert-tag alert-tag-orange" v-if="noTjbCountTotal > 0" @click="filterNoTjb">
                        <i class="el-icon-file-text"></i>
                        <span>体检表未导入：{{ noTjbCountTotal }}人</span>
                    </span>
                </el-tooltip>
            </div>

            <div class="data-table">
                <el-table 
                    :data="List" 
                    border 
                    stripe
                    style="width: 100%"
                    :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}"
                    empty-text="暂无数据"
                    ref="table"
                    height="calc(100vh - 400px)"
                    @filter-change="handleFilterChange">
                    
                    <el-table-column label="操作" width="100" fixed="left" align="center">
                        <template slot-scope="{ row }">
                            <el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
                        </template>
                    </el-table-column>
                    
                    <!-- 是否导入照片 -->
                    <el-table-column label="是否导入照片" width="120" align="center">
                        <template slot="header">
                            <span>是否导入照片</span>
                            <table-column-filter field="G_ZP" :options="getFilters('G_ZP')" :value="activeFilters['G_ZP']" @filter-change="handleCustomFilter" />
                        </template>
                        <template slot-scope="{ row }">
                            <el-tag v-if="getPhotoValue(row) !== ''" type="success" size="small">是</el-tag>
                            <el-tag v-else type="warning" size="small">否</el-tag>
                        </template>
                    </el-table-column>
                    
                    <!-- 是否导入体检表 -->
                    <el-table-column label="是否导入体检表" width="130" align="center">
                        <template slot="header">
                            <span>是否导入体检表</span>
                            <table-column-filter field="HasTJB" :options="getFilters('HasTJB')" :value="activeFilters['HasTJB']" @filter-change="handleCustomFilter" />
                        </template>
                        <template slot-scope="{ row }">
                            <el-tag v-if="getTjbValue(row) !== ''" type="success" size="small">是</el-tag>
                            <el-tag v-else type="warning" size="small">否</el-tag>
                        </template>
                    </el-table-column>
                    
                    <el-table-column 
                        v-for="col in columns"
                        :key="col.prop"
                        :prop="col.prop" 
                        :label="col.label" 
                        :width="col.width" 
                        align="center"
                        :show-overflow-tooltip="col.showOverflow">
                        <template slot="header">
                            <span>{{col.label}}</span>
                            <table-column-filter :field="col.prop" :options="getFilters(col.prop)" :value="activeFilters[col.prop]" @filter-change="handleCustomFilter" />
                        </template>
                    </el-table-column>
                    
                    <el-table-column prop="G_BDZT" label="报到状态" width="100" align="center">
                        <template slot="header">
                            <span>报到状态</span>
                            <table-column-filter field="G_BDZT" :options="getFilters('G_BDZT')" :value="activeFilters['G_BDZT']" @filter-change="handleCustomFilter" />
                        </template>
                        <template slot-scope="{ row }">
                            <el-tag v-if="row.G_BDZT=='已报到'" type="success" size="small">{{ row.G_BDZT }}</el-tag>
                            <el-tag v-else-if="row.G_BDZT=='未报到'" type="warning" size="small">{{ row.G_BDZT }}</el-tag>
                            <el-tag v-else type="info" size="small">{{ row.G_BDZT || '未知' }}</el-tag>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="报名表" width="120" align="center" fixed="right">
                        <template slot-scope="{ row }">
                            <el-button type="text" @click="openPrint(row, 'bmdjb')">
                                <i class="el-icon-document"></i> 查看
                            </el-button>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="成绩与志愿表" width="140" align="center" fixed="right">
                        <template slot-scope="{ row }">
                            <el-button type="text" @click="openPrint(row, 'cjzy')">
                                <i class="el-icon-document"></i> 查看
                            </el-button>
                        </template>
                    </el-table-column>
                    
                    <el-table-column label="体检表" width="120" align="center" fixed="right">
                        <template slot-scope="{ row }">
                            <el-button type="text" @click="openPrint(row, 'tjxx')">
                                <i class="el-icon-document"></i> 查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!-- 下载三表对话框 -->
            <el-dialog title="下载三表" :visible.sync="downloadDialogVisible" width="600px">
                <el-form :model="downloadForm" label-width="120px">
                    <el-form-item label="下载类型">
                        <el-checkbox-group v-model="downloadForm.genFileType">
                            <el-checkbox :label="1">报名登记表</el-checkbox>
                            <el-checkbox :label="2">成绩与志愿表</el-checkbox>
                            <el-checkbox :label="4">体检表</el-checkbox>
                            <el-checkbox :label="8">三表合一</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="文件命名">
                        <el-checkbox-group v-model="downloadForm.fileNameType">
                            <el-checkbox :label="1">省份</el-checkbox>
                            <el-checkbox :label="2">学院</el-checkbox>
                            <el-checkbox :label="4">专业</el-checkbox>
                            <el-checkbox :label="64">批次</el-checkbox>
                            <el-checkbox :label="8">考生号</el-checkbox>
                            <el-checkbox :label="16">证件号</el-checkbox>
                            <el-checkbox :label="32">姓名</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="任务标题" required>
                        <el-input v-model="downloadForm.title" placeholder="请输入任务标题（10字以内）" maxlength="10" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-alert title="生成规则说明" type="info" :closable="false">
                            <div>1. 将根据当前页面的筛选条件生成文件</div>
                            <div>2. 文件将在后台生成，请稍后在任务列表中查看</div>
                            <div>3. 文件命名将按照勾选的顺序组合</div>
                            <div>4. 勾选「三表合一」后，系统将生成一个包含三张表的合并PDF文件。若同时勾选前面的三张表选项，则会分别生成单独的三张表PDF，以及一个三表合一的PDF文件</div>

                        </el-alert>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="downloadDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleDownloadConfirm" :loading="downloadLoading">确 定</el-button>
                </span>
            </el-dialog>

            <!-- 自定义字段导出对话框 -->
            <el-dialog title="导出考生名单" :visible.sync="exportDialogVisible" width="760px" custom-class="export-dialog">
                <!-- 已保存方案 -->
                <div class="export-row">
                    <span class="export-label">已保存方案：</span>
                    <el-select v-model="currentSchemeId" placeholder="选择方案快速套用" clearable size="small"
                        style="width: 260px;" @change="onSchemeChange">
                        <el-option v-for="s in schemeList" :key="s.L_SN" :label="s.L_Title" :value="s.L_SN"></el-option>
                    </el-select>
                    <el-button type="danger" plain size="small" icon="el-icon-delete"
                        :disabled="!currentSchemeId" @click="deleteScheme" style="margin-left: 8px;">删除方案</el-button>
                    <span class="export-count">已选 {{ checkedFields.length }} / {{ totalFieldCount }} 项</span>
                </div>

                <!-- 工具行 -->
                <div class="export-row">
                    <el-input v-model="fieldSearch" placeholder="搜索字段名" clearable size="small" style="width: 260px;">
                        <i slot="prefix" class="el-icon-search"></i>
                    </el-input>
                    <el-button size="small" @click="selectAllFields">全选</el-button>
                    <el-button size="small" @click="clearAllFields">清空</el-button>
                    <el-button size="small" @click="invertFields">反选</el-button>
                </div>

                <!-- 字段分组勾选 -->
                <div class="field-panel" v-loading="fieldsLoading">
                    <el-collapse v-model="activeGroups">
                        <el-collapse-item v-for="g in filteredGroups" :key="g.group" :name="g.group">
                            <template slot="title">
                                <el-checkbox :value="isGroupChecked(g)" :indeterminate="isGroupIndeterminate(g)"
                                    @change="val => toggleGroup(g, val)" @click.native.stop>
                                    <span class="group-title">{{ g.group }}（{{ groupCheckedCount(g) }}/{{ g.fields.length }}）</span>
                                </el-checkbox>
                            </template>
                            <el-checkbox-group v-model="checkedFields">
                                <el-checkbox v-for="f in g.fields" :key="f.index" :label="f.index" class="field-checkbox">{{ f.label }}</el-checkbox>
                            </el-checkbox-group>
                        </el-collapse-item>
                    </el-collapse>
                    <div v-if="filteredGroups.length === 0" class="field-empty">没有匹配的字段</div>
                </div>

                <!-- 保存方案 -->
                <div class="export-row export-save-row">
                    <span class="export-label">方案名：</span>
                    <el-input v-model="schemeName" placeholder="输入名称后可存档复用" maxlength="10" show-word-limit
                        size="small" style="width: 260px;"></el-input>
                    <el-button type="primary" plain size="small" icon="el-icon-folder-add"
                        :loading="schemeSaving" @click="saveScheme" style="margin-left: 8px;">
                        {{ currentSchemeId ? '更新方案' : '保存为方案' }}
                    </el-button>
                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="exportDialogVisible = false">取 消</el-button>
                    <el-button type="success" icon="el-icon-download" @click="handleExportConfirm">导 出</el-button>
                </span>
            </el-dialog>
            
            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="PageInfo.CurPage"
                    :page-sizes="[20, 50, 100, 200]"
                    :page-size="PageInfo.RecordCountOfPage"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="PageInfo.RecordCount">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { TYBM_Env } from '../../env.js';
    import { TYBM_Tools } from '../../tools.js';
    import TableColumnFilter from '../Shared/TableColumnFilter.vue';

    export default {
        name: 'ListSanBiao',
        components: {
            TableColumnFilter
        },
        inject: ['Loading', 'LoadingCompleted'],
        computed: {
            noPhotoCount() {
                return this.noPhotoCountTotal;
            },
            // 全部字段总数
            totalFieldCount: function () {
                return this.fieldGroups.reduce((sum, g) => sum + g.fields.length, 0);
            },
            // 按搜索词过滤后的分组（隐藏无匹配的组）
            filteredGroups: function () {
                var kw = (this.fieldSearch || '').trim();
                if (!kw) {
                    return this.fieldGroups;
                }
                var result = [];
                this.fieldGroups.forEach(function (g) {
                    var fields = g.fields.filter(function (f) {
                        return f.label.indexOf(kw) >= 0;
                    });
                    if (fields.length > 0) {
                        result.push({ group: g.group, fields: fields });
                    }
                });
                return result;
            }
        },
        data: function () {
            return {
                Status: {
                    LoadingCompleted: false,
                    IsSubmiting: false,
                    ShowAdminColomn: true,
                    IsSelectAll: false
                },
                SelectedItemList: {
                    KaoShi: [],
                    Type: []
                },
                PageInfo: {
                    CurPage: 1,
                    PageCount: 1,
                    RecordCount: 1
                },
                CurSearch: '',
                photoFilter: '',
                List: [],
                noPhotoCountTotal: 0, // 总体未导入照片数量
                noTjbCountTotal: 0, // 总体未导入体检表数量
                // 筛选相关
                activeFilters: { // 当前激活的筛选条件 { prop: [values] }
                    G_ZP: [],
                    HasTJB: [],
                    CCMC: [],
                    JHLBMC: [],
                    G_Sheng: [],
                    KSH: [],
                    XM: [],
                    ZJHM: [],
                    PCMC: [],
                    KLMC: [],
                    G_XYMC: [],
                    LQZYMC: [],
                    BJ: [],
                    G_XH: [],
                    BH: [],
                    G_BDZT: []
                },
                allFilters: {}, // 所有可用的筛选选项
                
                columns: [
                    { prop: 'CCMC', label: '层次', width: 100 },
                    { prop: 'JHLBMC', label: '招生类型', width: 120 },
                    { prop: 'G_Sheng', label: '省份', width: 100 },
                    { prop: 'KSH', label: '考生号', width: 160, showOverflow: true },
                    { prop: 'XM', label: '姓名', width: 100 },
                    { prop: 'ZJHM', label: '证件号码', width: 180, showOverflow: true },
                    { prop: 'PCMC', label: '批次', width: 120 },
                    { prop: 'KLMC', label: '科类', width: 100 },
                    { prop: 'G_XYMC', label: '学院', width: 150, showOverflow: true },
                    { prop: 'LQZYMC', label: '专业名称', width: 200, showOverflow: true },
                    { prop: 'BJ', label: '班级', width: 100 },
                    { prop: 'G_XH', label: '学号', width: 140 },
                    { prop: 'BHSTR', label: '录取号', width: 140 }
                ],
                
                // 下载三表相关
                downloadDialogVisible: false,
                downloadLoading: false,
                downloadForm: {
                    genFileType: [1, 2, 4], // 默认全选
                    fileNameType: [],
                    title: ''
                },

                // 自定义字段导出相关
                exportDialogVisible: false,
                fieldsLoading: false,
                fieldsLoaded: false,      // 字段清单是否已从后端加载
                fieldGroups: [],          // [{ group, fields:[{index,label}] }]
                checkedFields: [],        // 选中的列下标数组
                fieldSearch: '',          // 字段搜索词
                activeGroups: [],         // 展开的分组名
                schemeList: [],           // 已保存方案 [{L_SN,L_Title,L_Content}]
                currentSchemeId: null,    // 当前选中方案 SN
                schemeName: '',           // 保存用方案名
                schemeSaving: false
            }
        },
        methods: {
            getPhotoValue(row) {
                if (row.G_ZP) return String(row.G_ZP).trim();
                if (row.g_zp) return String(row.g_zp).trim();
                return '';
            },
            getTjbValue(row) {
                if (row.HasTJB) return String(row.HasTJB).trim();
                if (row.hasTJB) return String(row.hasTJB).trim();
                return '';
            },
            getFilters(prop) {
                if (prop === 'G_ZP') {
                    return [
                        { text: '是', value: 'hasPhoto' },
                        { text: '否', value: 'noPhoto' }
                    ];
                }
                if (prop === 'HasTJB') {
                    return [
                        { text: '是', value: 'hasTJB' },
                        { text: '否', value: 'noTJB' }
                    ];
                }
                if (this.allFilters[prop]) {
                    return this.allFilters[prop];
                }
                return [];
            },
            handleCustomFilter({ field, values }) {
                // 更新筛选条件
                if (values && values.length > 0) {
                    this.$set(this.activeFilters, field, values);
                } else {
                    this.$delete(this.activeFilters, field);
                }
                // 重新从第一页加载数据
                this.LoadList(1);
            },
            filterNoPhoto() {
                this.handleCustomFilter({ field: 'G_ZP', values: ['noPhoto'] });
            },
            filterNoTjb() {
                this.handleCustomFilter({ field: 'HasTJB', values: ['noTJB'] });
            },
            OnSearch: function (type) {
                var that = this;
                if (type == 1) {
                    that.CurSearch = '';
                    that.photoFilter = '';
                    that.$set(that.activeFilters, 'G_ZP', []);
                    that.$set(that.activeFilters, 'HasTJB', []);
                    that.$set(that.activeFilters, 'CCMC', []);
                    that.$set(that.activeFilters, 'JHLBMC', []);
                    that.$set(that.activeFilters, 'G_Sheng', []);
                    that.$set(that.activeFilters, 'KSH', []);
                    that.$set(that.activeFilters, 'XM', []);
                    that.$set(that.activeFilters, 'ZJHM', []);
                    that.$set(that.activeFilters, 'PCMC', []);
                    that.$set(that.activeFilters, 'KLMC', []);
                    that.$set(that.activeFilters, 'G_XYMC', []);
                    that.$set(that.activeFilters, 'LQZYMC', []);
                    that.$set(that.activeFilters, 'BJ', []);
                    that.$set(that.activeFilters, 'G_XH', []);
                    that.$set(that.activeFilters, 'BH', []);
                    that.$set(that.activeFilters, 'G_BDZT', []);
                    that.LoadList();
                } else if (type == 2) {
                    that.LoadList();
                } else {
                    that.CurSearch = '';
                    that.photoFilter = '';
                    that.$set(that.activeFilters, 'G_ZP', []);
                    that.$set(that.activeFilters, 'HasTJB', []);
                    that.$set(that.activeFilters, 'CCMC', []);
                    that.$set(that.activeFilters, 'JHLBMC', []);
                    that.$set(that.activeFilters, 'G_Sheng', []);
                    that.$set(that.activeFilters, 'KSH', []);
                    that.$set(that.activeFilters, 'XM', []);
                    that.$set(that.activeFilters, 'ZJHM', []);
                    that.$set(that.activeFilters, 'PCMC', []);
                    that.$set(that.activeFilters, 'KLMC', []);
                    that.$set(that.activeFilters, 'G_XYMC', []);
                    that.$set(that.activeFilters, 'LQZYMC', []);
                    that.$set(that.activeFilters, 'BJ', []);
                    that.$set(that.activeFilters, 'G_XH', []);
                    that.$set(that.activeFilters, 'BH', []);
                    that.$set(that.activeFilters, 'G_BDZT', []);
                    that.LoadList();
                }
            },
            ToPage: function (pageIdx, pageCount) {
                var that = this;
                that.LoadList(pageIdx, pageCount);
                that.Status.IsSelectAll = false;
            },
            handleSizeChange(val) {
                this.ToPage(1, val);
            },
            handleCurrentChange(val) {
                this.ToPage(val, this.PageInfo.RecordCountOfPage);
            },
            LoadList: function (pageIdx, pageCount) {
                var that = this;

                var api_name = '/Info/GetListSanBiao';
                var url = TYBM_Env.GetApiUrl(api_name) + '?Search=' + encodeURIComponent(that.CurSearch || '');
                
                // 添加筛选条件
                Object.keys(that.activeFilters).forEach(function(key) {
                    var values = that.activeFilters[key];
                    if (values && values.length > 0) {
                        // Base64编码筛选值，避免分号、单引号等特殊字符触发SQL防注入模块拦截
                        url += '&Filter_' + key + '=' + encodeURIComponent(btoa(unescape(encodeURIComponent(values.join(',')))));
                    }
                });
                
                TYBM_Tools.AxiosGetEx(that, api_name, TYBM_Tools.AppendPageInfo(url, pageIdx, pageCount), { loading_msg: '正在加载数据' })
                    .then(result => {
                        that.PageInfo = result.data.PageInfo;
                        that.SelectedItemList = result.data.SelectedItemList;
                        that.List = result.data.List;
                        that.noPhotoCountTotal = result.data.NoPhotoCount || 0;
                        that.noTjbCountTotal = result.data.NoTjbCount || 0;
                        
                        // 更新所有可用的筛选选项
                        if (result.data.AllFilters) {
                            that.allFilters = result.data.AllFilters;
                        }
                        
                        that.Status.LoadingCompleted = true;
                    }).catch(() => { });
            },
            handleEdit: function (row) {
                // 打开编辑页面
                var url = '#/Info/SetKaoSheng/' + row.KSH;
                window.open(url, '_blank');
            },
            handleFilterChange() {
                // 筛选后重新布局，确保固定列对齐
                this.$nextTick(() => {
                    if (this.$refs.table) {
                        this.$refs.table.doLayout();
                    }
                });
            },
            openPrint: function (row, type) {
                var url = '';
                if (type === 'bmdjb') {
                    url = '/Gxzs/Print/SanBiaoBmdjb.aspx?info=' + row.KSMM;
                } else if (type === 'cjzy') {
                    url = '/Gxzs/Print/SanBiaoCjZy.aspx?info=' + row.KSMM;
                } else if (type === 'tjxx') {
                    url = '/Gxzs/Print/SanBiaoTjxx.aspx?info=' + row.KSMM;
                }
                window.open(url, '_blank');
            },
            GetDateTimeString: function (date) {
                return TYBM_Tools.FormatDate('yyyy-MM-dd HH:mm:ss', new Date(date));
            },
            handleExport: function () {
                var that = this;
                
                // 构建导出URL，传递当前查询条件和筛选条件
                var api_name = '/Info/ExportSanBiao';
                var url = TYBM_Env.GetApiUrl(api_name) + '?Search=' + encodeURIComponent(that.CurSearch || '');
                
                // 添加筛选条件
                Object.keys(that.activeFilters).forEach(function(key) {
                    var values = that.activeFilters[key];
                    if (values && values.length > 0) {
                        // Base64编码筛选值，避免分号、单引号等特殊字符触发SQL防注入模块拦截
                        url += '&Filter_' + key + '=' + encodeURIComponent(btoa(unescape(encodeURIComponent(values.join(',')))));
                    }
                });
                
                // 直接打开URL下载文件
                window.open(url, '_blank');
                that.$message.success('正在导出，请稍候...');
            },
            showDownloadDialog: function () {
                var that = this;
                that.downloadForm.title = '';
                that.downloadForm.genFileType = [1, 2, 4];
                that.downloadForm.fileNameType = [];
                that.downloadDialogVisible = true;
            },
            handleDownloadConfirm: function () {
                var that = this;
                
                // 验证
                if (that.downloadForm.genFileType.length === 0) {
                    that.$message.warning('请至少选择一个下载类型');
                    return;
                }
                
                if (that.downloadForm.fileNameType.length === 0) {
                    that.$message.warning('请至少选择一个文件命名规则');
                    return;
                }
                
                if (!that.downloadForm.title || that.downloadForm.title.trim() === '') {
                    that.$message.warning('请输入任务标题');
                    return;
                }
                
                if (that.downloadForm.title.length > 10) {
                    that.$message.warning('任务标题不能超过10个字');
                    return;
                }
                
                // 计算组合值
                var genFileTypeValue = that.downloadForm.genFileType.reduce(function(sum, val) { return sum + val; }, 0);
                var fileNameTypeValue = that.downloadForm.fileNameType.reduce(function(sum, val) { return sum + val; }, 0);
                
                // 构建筛选条件对象
                var filters = {};
                Object.keys(that.activeFilters).forEach(function(key) {
                    var values = that.activeFilters[key];
                    if (values && values.length > 0) {
                        filters[key] = values.join(',');
                    }
                });
                
                // 提交请求
                that.downloadLoading = true;
                var api_name = '/Info/DownloadSanBiao';
                var url = TYBM_Env.GetApiUrl(api_name);
                
                var payload = {
                    GenFileType: genFileTypeValue,
                    FileNameType: fileNameTypeValue,
                    Title: that.downloadForm.title,
                    Search: that.CurSearch || '',
                    Filters: filters
                };
                
                TYBM_Tools.AxiosPostEx(that, api_name, url, { Model: JSON.stringify(payload) }, { loading_msg: '正在创建任务...', has_progress: false })
                    .then(function(res) {
                        if (res.code === 'ok') {
                            that.$message.success('任务已创建，文件正在后台生成，请稍后查看');
                            that.downloadDialogVisible = false;
                        } else {
                            that.$message.error(res.errmsg || res.msg || '创建任务失败');
                        }
                    })
                    .catch(function() {
                        that.$message.error('创建任务失败');
                    })
                    .finally(function() {
                        that.downloadLoading = false;
                    });
            },

            // ===== 自定义字段导出 =====
            showExportDialog: function () {
                var that = this;
                that.exportDialogVisible = true;
                // 首次打开时加载字段清单与方案列表
                if (!that.fieldsLoaded) {
                    that.loadExportFields();
                }
                that.loadSchemeList();
            },
            loadExportFields: function () {
                var that = this;
                var api_name = '/Info/GetExportFields';
                var url = TYBM_Env.GetApiUrl(api_name);
                that.fieldsLoading = true;
                TYBM_Tools.AxiosGetEx(that, api_name, url, {})
                    .then(function (result) {
                        that.fieldGroups = result.data || [];
                        that.fieldsLoaded = true;
                        // 默认全选所有字段
                        that.selectAllFields();
                        // 默认展开所有分组
                        that.activeGroups = that.fieldGroups.map(function (g) { return g.group; });
                    })
                    .catch(function () { })
                    .finally(function () {
                        that.fieldsLoading = false;
                    });
            },
            loadSchemeList: function () {
                var that = this;
                var api_name = '/Info/GetExportSchemeList';
                var url = TYBM_Env.GetApiUrl(api_name);
                TYBM_Tools.AxiosGetEx(that, api_name, url, {})
                    .then(function (result) {
                        that.schemeList = result.data || [];
                    })
                    .catch(function () { });
            },
            // 分组勾选辅助
            groupCheckedCount: function (g) {
                var set = this.checkedFields;
                return g.fields.filter(function (f) { return set.indexOf(f.index) >= 0; }).length;
            },
            isGroupChecked: function (g) {
                return g.fields.length > 0 && this.groupCheckedCount(g) === g.fields.length;
            },
            isGroupIndeterminate: function (g) {
                var c = this.groupCheckedCount(g);
                return c > 0 && c < g.fields.length;
            },
            toggleGroup: function (g, val) {
                var that = this;
                g.fields.forEach(function (f) {
                    var idx = that.checkedFields.indexOf(f.index);
                    if (val && idx < 0) {
                        that.checkedFields.push(f.index);
                    } else if (!val && idx >= 0) {
                        that.checkedFields.splice(idx, 1);
                    }
                });
            },
            selectAllFields: function () {
                var all = [];
                this.fieldGroups.forEach(function (g) {
                    g.fields.forEach(function (f) { all.push(f.index); });
                });
                this.checkedFields = all;
            },
            clearAllFields: function () {
                this.checkedFields = [];
            },
            invertFields: function () {
                var current = this.checkedFields;
                var inverted = [];
                this.fieldGroups.forEach(function (g) {
                    g.fields.forEach(function (f) {
                        if (current.indexOf(f.index) < 0) {
                            inverted.push(f.index);
                        }
                    });
                });
                this.checkedFields = inverted;
            },
            onSchemeChange: function (id) {
                var that = this;
                if (!id) {
                    // 清除选择：保留当前勾选，允许改名后另存为新方案
                    that.currentSchemeId = null;
                    return;
                }
                var scheme = that.schemeList.filter(function (s) { return s.L_SN === id; })[0];
                if (!scheme) {
                    return;
                }
                that.currentSchemeId = id;
                that.schemeName = scheme.L_Title;
                // 解析下标串 → 仅保留有效下标
                var validSet = {};
                that.fieldGroups.forEach(function (g) {
                    g.fields.forEach(function (f) { validSet[f.index] = true; });
                });
                var arr = (scheme.L_Content || '').split(',')
                    .map(function (x) { return parseInt(x, 10); })
                    .filter(function (x) { return !isNaN(x) && validSet[x]; });
                that.checkedFields = arr;
            },
            handleExportConfirm: function () {
                var that = this;
                if (that.checkedFields.length === 0) {
                    that.$message.warning('请至少选择一个导出字段');
                    return;
                }

                // 构建导出URL，传递当前查询条件、筛选条件与选中字段
                var api_name = '/Info/ExportSanBiao';
                var url = TYBM_Env.GetApiUrl(api_name) + '?Search=' + encodeURIComponent(that.CurSearch || '');

                Object.keys(that.activeFilters).forEach(function (key) {
                    var values = that.activeFilters[key];
                    if (values && values.length > 0) {
                        url += '&Filter_' + key + '=' + encodeURIComponent(values.join(','));
                    }
                });

                // 追加选中字段（升序，保证列顺序为固定原顺序）
                var fields = that.checkedFields.slice().sort(function (a, b) { return a - b; });
                url += '&Fields=' + fields.join(',');

                window.open(url, '_blank');
                that.$message.success('正在导出，请稍候...');
                that.exportDialogVisible = false;
            },
            saveScheme: function () {
                var that = this;
                var name = (that.schemeName || '').trim();
                if (!name) {
                    that.$message.warning('请输入方案名');
                    return;
                }
                if (that.checkedFields.length === 0) {
                    that.$message.warning('请至少选择一个导出字段');
                    return;
                }

                var fields = that.checkedFields.slice().sort(function (a, b) { return a - b; });
                var payload = {
                    L_SN: that.currentSchemeId || 0,
                    Title: name,
                    Fields: fields.join(',')
                };

                var api_name = '/Info/SaveExportScheme';
                var url = TYBM_Env.GetApiUrl(api_name);
                that.schemeSaving = true;
                TYBM_Tools.AxiosPostEx(that, api_name, url, { Model: JSON.stringify(payload) }, { loading_msg: '正在保存方案...' })
                    .then(function (res) {
                        that.$message.success('方案已保存');
                        if (res.data && res.data.L_SN) {
                            that.currentSchemeId = res.data.L_SN;
                        }
                        that.loadSchemeList();
                    })
                    .catch(function () { })
                    .finally(function () {
                        that.schemeSaving = false;
                    });
            },
            deleteScheme: function () {
                var that = this;
                if (!that.currentSchemeId) {
                    return;
                }
                that.$confirm('确定删除该方案吗？', '温馨提示', { type: 'warning' })
                    .then(function () {
                        var api_name = '/Info/DeleteExportScheme';
                        var url = TYBM_Env.GetApiUrl(api_name);
                        TYBM_Tools.AxiosPostEx(that, api_name, url, { Model: JSON.stringify({ L_SN: that.currentSchemeId }) }, { loading_msg: '正在删除...' })
                            .then(function () {
                                that.$message.success('删除成功');
                                that.currentSchemeId = null;
                                that.schemeName = '';
                                that.loadSchemeList();
                            })
                            .catch(function () { });
                    })
                    .catch(function () { });
            }
        },
        created: function () {
            var that = this;
            that.PageInfo.CurPage = that.$route.query.Page || 1;
            that.LoadList();
        }
    }
</script>

<style scoped>
.san-biao-container {
    width: 100%;
}

.search-box {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
    align-items: center;
}

.data-table {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
}

.data-table >>> .el-table {
    font-size: 13px;
}

/* 统一控制 th 和 td 的基础样式 */
.data-table >>> .el-table th,
.data-table >>> .el-table td {
    padding: 0 !important;
    height: 40px !important;
}

/* 表头特定样式 */
.data-table >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

/* 强制每行高度一致 */
.data-table >>> .el-table__row {
    height: 40px !important;
}

.data-table >>> .el-table__row:hover {
    background-color: #f5f9ff;
}

.alert-bar {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 12px;
}

.alert-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: opacity 0.2s;
}

.alert-tag:hover {
    opacity: 0.85;
}

.alert-tag-red {
    background-color: #FDEDED;
    color: #D93026;
}

.alert-tag-orange {
    background-color: #FFF4E0;
    color: #FA8C16;
}

.alert-tag i {
    font-size: 14px;
}

.pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: center;
}

/* 打印链接样式 */
.data-table >>> .el-button--text {
    color: #409EFF;
    padding: 0;
}

.data-table >>> .el-button--text:hover {
    color: #66b1ff;
}

/* 单元格内容控制 */
.data-table >>> .el-table .cell {
    padding: 0 8px !important;
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    line-height: 40px !important;
}

/* 表头单元格特殊处理：使用 Flex 布局垂直居中，防止图标撑开 */
.data-table >>> .el-table th > .cell {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: 100% !important;
    line-height: normal !important;
}

.data-table >>> .el-button--text i {
    margin-right: 4px;
}

/* 固定列背景色（不透明） */
.data-table >>> .el-table__fixed-right {
    background-color: white !important;
}

.data-table >>> .el-table__fixed-right .el-table__fixed-body-wrapper {
    background-color: white !important;
}

.data-table >>> .el-table__fixed-right-patch {
    background-color: #f5f7fa !important;
}

.data-table >>> .el-table__fixed-right .el-table__body tr {
    background-color: white !important;
}

.data-table >>> .el-table__fixed-right .el-table__body tr:hover {
    background-color: #f5f9ff !important;
}

.data-table >>> .el-table__fixed-right .el-table__body tr.el-table__row--striped {
    background-color: #fafafa !important;
}

.data-table >>> .el-table__fixed-right .el-table__body tr.el-table__row--striped:hover {
    background-color: #f5f9ff !important;
}

/* 自定义字段导出对话框 */
.export-row {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    flex-wrap: wrap;
    gap: 8px;
}

.export-label {
    font-size: 13px;
    color: #606266;
    white-space: nowrap;
}

.export-count {
    margin-left: auto;
    font-size: 13px;
    color: #909399;
}

.field-panel {
    max-height: 380px;
    overflow-y: auto;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 0 12px;
}

.field-panel .group-title {
    font-weight: 600;
    color: #303133;
}

.field-panel .field-checkbox {
    width: 160px;
    margin-left: 0;
    margin-right: 0;
}

.field-empty {
    text-align: center;
    color: #909399;
    padding: 30px 0;
    font-size: 13px;
}

.export-save-row {
    margin-top: 12px;
    margin-bottom: 0;
    padding-top: 12px;
    border-top: 1px solid #ebeef5;
}
</style>